import React from 'react';

const DistanceSalesContractPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow-lg rounded-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">
            Mesafeli Satış Sözleşmesi
          </h1>
          
          <div className="prose prose-lg max-w-none">
            <h2 className="text-xl font-semibold mb-4">MADDE 1 - TARAFLAR</h2>
            
            <h3 className="text-lg font-semibold mb-3">1.1. SATICI</h3>
            <div className="bg-gray-100 p-4 rounded-lg mb-4">
              <p><strong>Unvan:</strong> Fiel Home</p>
              <p><strong>Adres:</strong> MAHMUDİYE MAH. ERTUĞRUL GAZİ CAD. NO: 46 A İNEGÖL/BURSA</p>
              <p><strong>Telefon:</strong> +90 552 229 90 07</p>
              <p><strong>E-posta:</strong> info@fielhome.com</p>
              <p><strong>Vergi Kimlik No:</strong> 7661111486</p>
              <p><strong>Vergi Dairesi:</strong> İnegöl</p>
              <p><strong>Faaliyet Kodu:</strong> 464701 - MOBİLYA VE MOBİLYA AKSESUARLARI TOPTAN TİCARETİ</p>
            </div>
            
            <h3 className="text-lg font-semibold mb-3">1.2. ALICI</h3>
            <p className="mb-4">
              Sipariş formunda belirtilen kişi/kurum bilgileri
            </p>
            
            <h2 className="text-xl font-semibold mb-4">MADDE 2 - KONU</h2>
            <p className="mb-4">
              Bu sözleşme, ALICI'nın SATICI'ya ait www.fielhome.com internet sitesi 
              üzerinden elektronik ortamda siparişini verdiği aşağıda nitelikleri 
              ve satış fiyatı belirtilen ürün/ürünlerin satışı ve teslimi ile 
              ilgili tarafların hak ve yükümlülüklerini düzenler.
            </p>
            
            <h2 className="text-xl font-semibold mb-4">MADDE 3 - SÖZLEŞME KONUSU ÜRÜN/HİZMET BİLGİLERİ</h2>
            <p className="mb-4">
              Ürün/hizmet bilgileri sipariş özeti sayfasında detaylı olarak yer almaktadır.
            </p>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Ürün adı, miktarı, marka/modeli, rengi</li>
              <li>Toplam satış bedeli (KDV dahil)</li>
              <li>Ödeme şekli ve planı</li>
              <li>Teslimat bilgileri</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">MADDE 4 - GENEL HÜKÜMLER</h2>
            <h3 className="text-lg font-semibold mb-3">4.1. Ödeme</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Kredi kartı, banka kartı ile online ödeme</li>
              <li>Havale/EFT ile ödeme</li>
              <li>Kapıda ödeme (belirtilen ürünlerde)</li>
              <li>Taksitli ödeme seçenekleri</li>
            </ul>
            
            <h3 className="text-lg font-semibold mb-3">4.2. Teslimat</h3>
            <p className="mb-4">
              Ürünler ALICI'nın belirttiği adrese teslim edilir:
            </p>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Teslimat süresi: 3-15 iş günü (ürüne göre değişir)</li>
              <li>Kargo ücreti: Sepet tutarına göre belirlenir</li>
              <li>Büyük mobilyalar için kurulum hizmeti sunulur</li>
              <li>Teslimat saatleri: 09:00-18:00 arası</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">MADDE 5 - CAYMA HAKKI</h2>
            <p className="mb-4">
              ALICI, 14 gün içinde herhangi bir gerekçe göstermeksizin ve cezai şart 
              ödemeksizin sözleşmeden cayabilir.
            </p>
            
            <h3 className="text-lg font-semibold mb-3">5.1. Cayma Hakkının Kullanılması</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Cayma süresi: Ürün teslim tarihinden itibaren 14 gün</li>
              <li>Ürün kullanılmamış ve ambalajında olmalıdır</li>
              <li>Cayma bildirimi yazılı olarak yapılmalıdır</li>
              <li>İade kargo ücreti alıcıya aittir</li>
            </ul>
            
            <h3 className="text-lg font-semibold mb-3">5.2. Cayma Hakkının Kullanılamadığı Durumlar</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Kişiye özel üretilen ürünler</li>
              <li>Hijyen açısından iade edilmesi uygun olmayan ürünler</li>
              <li>Özel sipariş üzerine üretilen mobilyalar</li>
              <li>Montajı yapılan ve kullanılan ürünler</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">MADDE 6 - GARANTİ</h2>
            <p className="mb-4">
              Tüm ürünler için üretici garantisi geçerlidir:
            </p>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Garanti süreleri ürün özelliklerine göre değişir</li>
              <li>Garanti kapsamı üretici koşullarına bağlıdır</li>
              <li>Garanti belgesi ürün ile birlikte teslim edilir</li>
              <li>Yetkili servis ağı üzerinden garanti hizmeti sunulur</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">MADDE 7 - TEMERRÜT VE HUKUKİ SONUÇLARI</h2>
            <h3 className="text-lg font-semibold mb-3">7.1. ALICI'nın Temerrüdü</h3>
            <p className="mb-4">
              ALICI ödeme yapmadığı takdirde faiz ve temerrüt uygulanır.
            </p>
            
            <h3 className="text-lg font-semibold mb-3">7.2. SATICI'nın Temerrüdü</h3>
            <p className="mb-4">
              SATICI teslimat yapmadığı takdirde tazminat ödemekle yükümlüdür.
            </p>
            
            <h2 className="text-xl font-semibold mb-4">MADDE 8 - YETKİLİ MAHKEME</h2>
            <p className="mb-4">
              Bu sözleşmeden doğan uyuşmazlıklarda İnegöl Mahkemeleri ve 
              İcra Müdürlükleri yetkilidir.
            </p>
            
            <h2 className="text-xl font-semibold mb-4">MADDE 9 - YÜRÜRLÜK</h2>
            <p className="mb-4">
              Bu sözleşme, ALICI tarafından elektronik ortamda onaylandığı 
              anda yürürlüğe girer.
            </p>
            
            <div className="mt-8 p-4 bg-blue-50 rounded-lg">
              <p className="text-sm text-blue-800">
                <strong>ÖNEMLİ:</strong> Bu sözleşmeyi kabul etmekle, yukarıdaki 
                tüm şartları okuduğunuzu ve kabul ettiğinizi beyan etmiş olursunuz.
              </p>
            </div>
            
            <p className="mt-8 text-sm text-gray-600">
              Bu sözleşme {new Date().toLocaleDateString('tr-TR')} tarihinde güncellenmiştir.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DistanceSalesContractPage;
